import React, { useEffect, useState } from "react";
import { Card, CardMedia, Typography,  Box ,Button} from "@material-ui/core";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import { Link } from 'react-router-dom';
import { useAuth } from "../util/auth.js";
import { makeStyles } from "@material-ui/styles";
import { useCardDataContext } from "./CardDataContext.js";
import { blogAdmins, blogUrl } from "../util/blogFeaturesSettings.js";
const useStyles = makeStyles((theme) => ({
  media: {
    width: "100%",
    height: "250px",
    maxHeight: "250px",
    objectFit: "cover",
    transformOrigin: "center center",
    transition: "transform 0.3s",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
}));

const BlogCard = ({ id, imgSrc, imgAlt, title, description }) => {
  const classes = useStyles();
  const {updateCardCount,blogMetaData}=useCardDataContext();
  const auth = useAuth();
  const [slugTitle, setSlugTitle] = useState("");
  
  useEffect(() => {
    // Example usage
    const foundSlugTitle = findSlugTitleById(id);

    // Set the slugTitle state
    setSlugTitle(foundSlugTitle);
  }, [id, blogMetaData]);

  const findSlugTitleById = (id) => {
    const foundData = blogMetaData.find((data) => data.id === id);
    return foundData ? foundData.slugTitle : 'default-slug-title';
  };

  // console.log("slugTitle:", slugTitle);

  
  const truncateWords = (str, numWords) => {
    if (typeof str !== 'string') {
      return str; // If str is not a string, return it as is
    }
    const words = str.split(' ');
    if (words.length > numWords) {
      return words.slice(0, numWords).join(' ') + '...';
    }
    return str;
  };
  const handleDelete = async () => {
    // Ask the user for confirmation
    const userConfirmed = window.confirm("Are you sure you want to delete this blog?");
  
    // If the user confirms, proceed with deletion
    if (userConfirmed) {
      try {
        // Perform the specific delete operation here
        const dataDeleted = await deleteDataById(`${blogUrl}/api/tasks`, id);
        // console.log("Data deleted successfully:", dataDeleted);
  
        // Update the card count
        updateCardCount((prevCount) => prevCount - 1);

        alert("Blog deleted successfully!");
  
        // Optionally, you can navigate to another page after successful deletion
        // history.push("/someOtherPage");
  
        // Alternatively, you can fetch updated data or perform any other required actions
  
      } catch (error) {
        console.error("Error deleting data:", error.message);
        // Handle the error in a different way, if needed
        // For example, show an error message to the user
        alert("Error deleting blog. Please try again.");
      }
    }
    // If the user cancels, do nothing
  };
  

  async function deleteDataById(apiUrl, id) {
    try {
      const response = await fetch(`${apiUrl}/${id}`, {
        method: "DELETE", // Correct the method to DELETE
        headers: {
          'Content-Type': 'application/json',
          // Add any additional headers if needed
        },
      });
  
      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }
  
      const data = await response.json();
      // console.log('Data Deleted successfully:', data);
      return data;
    } catch (error) {
      console.error('Error deleting data:', error.message);
      return null; // or handle the error in a different way
    }
  }
  
  return (
    <Card
      component={Link}
      to={`/blogPage/${slugTitle}`}  // Use slugTitle in the URL

      style={{
        flexDirection: "column",
        backgroundColor: "rgba(23, 162, 184, 0.2)",
        minWidth: "320px",
        height:"100%",
        maxHeight: "500px",
        borderRadius: "10px",
        display: "flex",
        margin: "auto auto",
        boxShadow: "1px 1px 2px rgba(255, 255,255, 0.2)",
        cursor: "pointer",
        textDecoration: 'none',
      }}
    >
      <CardMedia
        component="img"
        src={imgSrc}
        alt={imgAlt}
        className={classes.media}
      />
           {/* {auth.user && auth.user.email==="shivamsingh.comp1999@gmail.com" && <Box style={{ display: 'flex', gap: '5px', justifyContent: 'space-between' }}> */}

           {auth.user && blogAdmins.includes(auth.user.email) && (
  <Box>
    <Button component={Link} to={`/updateBlog/${id}`}>
      <Edit />
      <span style={{ color: 'white' }}>Edit</span>
    </Button>
    <Button onClick={handleDelete} component={Link} to={`/blogList`}>
      <Delete />
      <span style={{ color: 'white' }}>Delete</span>
    </Button>
  </Box>
)}

      <Box flex px={1} sx={{ flexDirection: "column", flexWrap: "wrap", marginY: "10px" }}>
        <Typography
          variant="h6"
          gutterBottom
          style={{ fontWeight: "bold" }}
        >
          {title}
        </Typography>
        <Typography
  variant="button"
  style={{  fontSize: "0.6rem" }}
>
{`${description.slice(0, 110)}...`}
</Typography>
      </Box>
    </Card>
  );
};

export default BlogCard;
